export function pendoModule(id, pendoKey) {
  return `(function(){
      const pendoScript = function(cb) {
        (function(p, e, n, d, o) {
            var v, w, x, y, z;
            o = p[d] = p[d] || {};
            o._q = [];
            v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
            for (w = 0, x = v.length; w < x; ++
                w)(function(m) {
                o[m] = o[m] || function() {
                    o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                };
            })(v[w]);
            y = e.createElement(n);
            y.id = 'pendo-tracker';
            y.async = !0;
            y.onload = cb;
            y.src = 'https://cdn.pendo.io/agent/static/'+'${pendoKey}'+'/pendo.js'; e.head.appendChild(y);})(window,document ,'script','pendo');
        };

      // OneTrust consent cookie
      
      const ONETRUST_CONSENT_COOKIE = 'OptanonConsent';
      
      const ONETRUST_COOKIE_CATEGORIZATION_ATTRIBUTE = 'groups';
  
      
      const ONETRUST_COOKIE_CATEGORIZATIONS = {
        C0001: 'StrictlyNecessary',
        C0002: 'Performance',
        C0003: 'Functional',
        C0004: 'AcceptAll',
      };
  
      /**
      * Decode the cookie data and extract the attribute details.
      * @param {string} attribute - The attribute to search in the cookie data.
      * @param {string[]} cookieData - The cookie data as an array.
      * @returns {string | null}
      */
      
      function decodeCookieData(attribute, cookieData) {
        for (const element of cookieData) {
          const data = element.trim();
          const key = data.split('=')[0];
          if (key === attribute) {
            return data.substring(key.length + 1);
          }
        }
        return null;
      }
  
      /**
      * Extract the cookie categorizations
      * @param {string} categories - the cookie categories related to Strictly Necessary, Performance, Functional.
      * @returns {object | undefined}
      * @example
      * // Basic usage:
      * extractCookieCategorizations('C0001:1,C0003:1,C0002:1,C0004:1');
      */
      
      function extractCookieCategorizations(categories) {
        const cookieCategories = categories ? categories.split(',') : [];
        if (cookieCategories.length) {
          const cookieSpecifications = {};
          for (const categoryDetails of cookieCategories) {
            const [categoryKey, categoryValue] = categoryDetails.split(':');
            const cookieName = ONETRUST_COOKIE_CATEGORIZATIONS[categoryKey];
            if (cookieName) {
              cookieSpecifications[cookieName] = categoryValue === '1';
            }
          }
          return cookieSpecifications;
        }
        return undefined;
      }
  
      /**
      * Get the OneTrust cookie categories
      * @returns {object | undefined}
      */
      
      function getOneTrustCookies() {
        const cookies = document.cookie.split(';');
        const oneTrustCookie = decodeCookieData(ONETRUST_CONSENT_COOKIE, cookies);
        if (oneTrustCookie) {
          const decodedCookie = decodeURIComponent(oneTrustCookie);
          const cookieGroup = decodeCookieData(ONETRUST_COOKIE_CATEGORIZATION_ATTRIBUTE, decodedCookie.split('&'));
          const userSelectedPreferences = extractCookieCategorizations(cookieGroup);
          // eslint-disable-next-line no-console
          console.log('OneTrust: User selected preferences', userSelectedPreferences);
          return userSelectedPreferences;
        }
        // eslint-disable-next-line no-console
        console.warn('OneTrust: No Cookie detected.');
  
        return undefined;
      }
  
      
      const loadPendoScript = () => {
        if (!document.getElementById('pendo-tracker')) {
          pendoScript(triggerPendoLoadedEvent);
        }
      };

      const triggerPendoLoadedEvent = () => {
        const customEvent = new CustomEvent("pendo-loaded", { detail: {
          pendoInitialize
        }});
        window.dispatchEvent(customEvent);
      };
  
      
      const pendoInitialize = (vistiorObj) => {
        if (window.pendo) {
          const optionalData = createOptionalParams();
          const userAnalyticsConsent = isPerformanceCookieAccepted();
          window.pendo.initialize({
            visitor: {
              id: '${id}',
              userAnalyticsConsent,
              ...vistiorObj
            },
            // Can send the below info if needed
            // account: {
            //     // id: ‘ACCOUNT-UNIQUE-ID’ // Highly recommended
            //     // name: // Optional
            //     // planLevel: // Optional
            //     // planPrice: // Optional
            //     // creationDate: // Optional
            //     // You can add any additional account level key-values here, // as long as it’s not one of the above reserved names.
            // },
            ...optionalData,
          });
        } else {
          // eslint-disable-next-line
          console.log('Pendo script not loaded, or consent not given.');
        }
      };
  
      
      // const triggerPendoInitialTracking = (trackingKey, trackingObj) => {
      //   if (window.pendo) {
      //     window.pendo.track(trackingKey, {
      //       // cohortId,
      //       // deploymentId,
      //       // pearsonUid,
      //       // courseName: screenTitle,
      //       ...trackingObj
      //     });
      //   }
      // };
  
      
      const createOptionalParams = () => {
        const oneTrustCookiePreferences = getOneTrustCookies();
  
        if (oneTrustCookiePreferences) {
          const { Performance, AcceptAll } = oneTrustCookiePreferences;
  
          if (AcceptAll || Performance) {
            return {};
          }
        }
  
        return {
          analytics: { excludeEvents: ['load', 'click', 'focus', 'submit', 'change', 'track'] },
        };
      };
  
      
      const isPerformanceCookieAccepted = () => {
        const oneTrustCookiePreferences = getOneTrustCookies();
        if (oneTrustCookiePreferences) {
          const { Performance, AcceptAll } = oneTrustCookiePreferences;
  
          if (AcceptAll || Performance) {
            return true;
          }
        }
  
        return false;
      };
  
      loadPendoScript();
  
      window.pendoModule = {
        pendoInitialize
      }
    })()
    `;
}
